module.exports = __webpack_public_path__ + "media/highclass/example-2-3b660ce5.webp";